import type { AuthErrorState } from './auth-error'

// Minimal auth-session bridge (ADR-0011). The Axios client cannot call
// React hooks, so it reads the CURRENT OIDC session through this narrow seam. The
// bridge is NOT a second session owner and stores NO tokens — it delegates to the
// provider-owned OIDC user (registered by AuthBridgeRegistrar). Ownership
// and reset are explicit and covered by tests.

export interface AuthBridge {
	/** The current, non-expired OIDC access token, or undefined. */
	getAccessToken(): string | undefined
	/** Attempt one library-supported silent renewal; resolves to a new token or null. */
	renew(): Promise<string | null>
	/** Remove the provider-owned OIDC user and clear Atlas `/users/auth/me` state. */
	clearSession(): Promise<void>
	/** Start one interactive login redirect (signinRedirect). */
	startLogin(): void
	/** Publish the typed session-level auth-error state to the UI store. */
	setAuthErrorState(state: AuthErrorState | null): void
}

let bridge: AuthBridge | null = null

export function setAuthBridge(next: AuthBridge | null): void {
	bridge = next
}

export function getAuthBridge(): AuthBridge | null {
	return bridge
}
